// src/context/MainContext.js

import React, { createContext, useState } from 'react';
import WalletProvider from './WalletContext';
import StakingProvider from './StakingContext';
import MiningProvider from './MiningContext';
import BalanceProvider from './BalanceContext';
import NFTProvider from './NFTContext'; // Existing NFT Context (CashNFT)
import BoosterNFTProvider from './BoosterNFTContext'; // Import Booster NFT Provider
import LPStakingProvider from './LPStakingContext'; // Import LP Staking Provider

export const MainContext = createContext();

const MainProvider = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  // TODO: Add logic to track overall initialization across contexts if needed

  return (
    <MainContext.Provider value={{ isInitialized, setIsInitialized }}>
      <WalletProvider>
        <MiningProvider> {/* Moved up - NFTProvider depends on this */}
          <StakingProvider> {/* Moved up - NFTProvider depends on this */}
            <NFTProvider> {/* Now MiningContext and StakingContext are available */}
              <BoosterNFTProvider>
                <LPStakingProvider>
                  <BalanceProvider>
                    {children}
                  </BalanceProvider>
                </LPStakingProvider>
              </BoosterNFTProvider>
            </NFTProvider>
          </StakingProvider>
        </MiningProvider>
      </WalletProvider>
    </MainContext.Provider>
  );
};

export default MainProvider;